import { cached } from '@porotutu/react'
import { listQueryOf } from '@porotutu/react/paging'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { CRM_REDEMPTION_SORTABLE, REDEMPTION_RESULTS, REDEMPTION_STATUSES } from '../vocabulary'
import { redemptionQuery, redemptionsQuery } from './queries'

const redemptionSearch = (raw: Record<string, unknown>) =>
  listQueryOf(raw, CRM_REDEMPTION_SORTABLE, [], ['customer_id'], {
    result: REDEMPTION_RESULTS,
    status: REDEMPTION_STATUSES,
  })

export const redemptionsRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('redemptions'),
  path: '/redemptions',
  validateSearch: redemptionSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.query(cached(redemptionsQuery(deps))),
  component: lazyRouteComponent(() => import('./pages'), 'RedemptionsPage'),
})

export const redemptionRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('redemptions'),
  path: '/redemptions/$id',
  validateSearch: redemptionSearch,
  loader: ({ context, params }) => context.queryClient.query(cached(redemptionQuery(params.id))),
  component: lazyRouteComponent(() => import('./pages'), 'RedemptionPage'),
})

export const redemptionRoutes = [redemptionsRoute, redemptionRoute]
